import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimeUserApprovalState = atom({
  key: "myTimeUserApprovalState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
